import {useQuery} from "@tanstack/react-query";
import { postCustomerAccountReadPtaTotalListApi } from "../../../../../api/correspondent/tierApi";

interface PTASearchProps {
    itemName: string;
    keyword: string;
    keywordType: string;
    limit: number;
    pageNo: number;
    partNo: string;
    month: string;
    year: string;
}

/**
 * 거래처 기본 정보 가져오기
 * @param props
 * @returns
 */
export const usePostCustomerAccountReadPtaTotalList = (data: PTASearchProps) => {
    return useQuery({
        queryKey: ["postCustomerAccountReadPtaTotalList", data],
        queryFn: () => 
            postCustomerAccountReadPtaTotalListApi({
                keyword: data?.keyword,
                keywordType: data?.keywordType,
                itemName: data?.itemName,
                partNo: data?.partNo,
                pageNo: data?.pageNo,
                limit: data?.limit,
                searchMonth: `${data?.year}-${data?.month.padStart(2, "0")}`
            })
        ,
        select: (res) => res,
        // staleTime: 6000 * 10,
        enabled:  !!data?.month && !!data?.year,
    });
};
